var vendorsTable;

var vendorsTable;
var vendorsTableOnChangeDisabled = false;

var vendorsTypesTable;
           
var vendorsTypesTable;
var vendorsTypesTableOnChangeDisabled = false;

var vendorsAutoAdmitTable;
var vendorsAutoAdmitTableOnChangeDisabled = false;

function CreateVendorTables(dateFormat, vendorTypes) {

    console.log("vendor types 0 is");
    console.log(vendorTypes);

 

    var vendorTypesToDisplay = defaultVendors;
    if (vendorTypes != null) {
        vendorTypesToDisplay = [];

        var vendorTypesCount = vendorTypes.length;
        for (var vx = 0; vx < vendorTypesCount; vx++) {
            vendorTypesToDisplay.push(vendorTypes[vx].vendorTypeName);
        }
    }

    var tableHeight = window.innerHeight - 64 - 256;

    if (tableHeight < 256) {
        tableHeight = 256;
    }



    var menuWidth = 250;
    var pageMarginAndPaddingTotal = 100;

    var tableWidth = window.innerWidth - menuWidth - pageMarginAndPaddingTotal;

    window.addEventListener('resize', function (event) {
        var newWidth = window.innerWidth - menuWidth - pageMarginAndPaddingTotal;
        $('#vendors .jexcel_content').width(newWidth);
        $('#vendorautoadmitgrid .jexcel_content').width(newWidth);
        $('#vendortypesgrid .jexcel_content').width(newWidth);
        
    }, true);

    vendorsTable = jexcel(document.getElementById('vendors'), {
        allowManualInsertColumn: false,
        allowInsertColumn: false,
        allowDeleteColumn: false,
        allowRenameColumn: false,
        columnDrag: false,
        data: null,
        search: true,
        tableWidth: tableWidth + 'px',
        tableHeight: tableHeight + 'px',
        minDimensions: [2, 100],
        tableOverflow: true,
        columns: [
            {
                title: 'Name',
                type: 'string',
                width: '300px',
            },
            {
                title: 'Type',
                type: 'dropdown',
                source: vendorTypesToDisplay,
                width: '250px',
            },
            {
                title: 'Representative',
                type: 'text',
                width: '150px',
            },
            {
                title: 'Plate number',
                type: 'text',
                width: '150px',
            },
            {
                title: 'Insurance required',
                type: 'checkbox',
                width: '150px',
            },
            {
                title: 'Insurance on file',
                type: 'checkbox',
                width: '150px',
            },
            {
                title: 'Insurance expiration date',
                type: 'calendar', options: { format: dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY' },
                width: '220px',
            },
            {
                title: 'Comment',
                type: 'text',
                width: '150px',
                wordWrap: true
            }
        ],
        onload: function (instance) {

            $($(instance).find('.jexcel_filter')).each(function (i, obj) {
                $(obj).prepend($("#vendors-header-title"));
            });
            $(".jexcel_search").css({ "border": "1px solid #ccc" });
            $(".jexcel_search").css({ "margin-top": "20px" });


        },
        rowResize: true
    });




    vendorsTypesTable = jexcel(document.getElementById('vendortypesgrid'), {
        allowManualInsertColumn: false,
        allowInsertColumn: false,
        allowDeleteColumn: false,
        allowRenameColumn: false,
        columnDrag: false,
        data: null,
        search: false,
        tableHeight: tableHeight + 'px',
        minDimensions: [2, 100],
        tableOverflow: true,
        columns: [
            {
                title: 'Type name',
                type: 'string',
                width: '300px',
            },
            {
                title: 'Description',
                type: 'text',
                width: '500px',
            },
        ],
        onload: function (instance) {

        },
        rowResize: true
    });


    return 1;
}

function BuildVendorsAutoAdmitTable(dateFormat, vendorsInDatabase) {


    console.log("vendorsInDatabase");
    console.log(vendorsInDatabase);

    var vendorNames = [];

    vendorsInDatabase.forEach(vendor => vendorNames.push(
        vendor.vendorName));

    

    var residentTerm = "Resident";

    var tableHeight = window.innerHeight - 64 - 256;

    if (tableHeight < 256) {
        tableHeight = 256;
    }

    console.log(vendorNames);

    var receiverUnits = [];
    var receiverNames = [];

    var receiversInCacheCount = receiversCache.length;
    for (var i = 0; i < receiversInCacheCount; i++) {

        var rowValue = receiversCache[i]['receiverUnit'];
        if (isEmptyOrSpaces(rowValue) == false) {
            receiverUnits.push(rowValue);
        }

        rowValue = receiversCache[i]['receiverName'];
        if (isEmptyOrSpaces(rowValue) == false) {
            receiverNames.push(rowValue);
        }
    }

    vendorsAutoAdmitTable = jexcel(document.getElementById('vendorautoadmitgrid'), {
        allowManualInsertColumn: false,
        allowInsertColumn: false,
        allowDeleteColumn: false,
        allowRenameColumn: false,
        columnDrag: false,
        data: null,
        tableWidth: '100%',
        tableHeight: tableHeight + 'px',
        minDimensions: [2, 100],
        wordWrap: true,
        search: true,
        tableOverflow: true,
        columns: [
            {
                title: 'Vendor',
                type: 'dropdown',
                source: vendorNames,
                width: '250px',
            },
            {
                title: '',
                type: 'text',
                width: '2px',
            },
            {
                title: 'Unit',
                type: 'dropdown',
                source: receiverUnits,
                width: '150px',
                multiple: false
            },
            {
                title: 'Name',
                type: 'text',
                width: '200px',
            },
            {
                title: 'Errand',
                type: 'text',
                width: '200px',
            },
            {
                title: 'Duration',
                type: 'dropdown',
                source: ['Temporary', 'Permanent'],
                width: '150px',
                multiple: false
            },
            {
                title: 'Entry from',
                type: 'calendar', options: { format: dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY' },
                width: '150px',
            },
            {
                title: 'Entry to',
                type: 'calendar', options: { format: dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY' },
                width: '150px',
            },
            {
                title: 'Banned',
                type: 'dropdown',
                source: ['Allow', 'Banned'],
                width: '100px',
                multiple: false
            },
            {
                title: 'Comment',
                type: 'text',
                width: '100px',
                wordWrap: true
            },
            {
                title: 'Pass',
                type: 'text',
                width: '60px'
            },
        ],
        rowResize: true,
        onload: function (instance) {
            //Seperator colors

            $($(instance).find('td[data-x="1"]')).each(function (i, obj) {
                $(obj).css("background-color", "#ccc");
            });

            $($(instance).find('td[data-x="0"]')).each(function (i, obj) {
                if (i == 0) {
                    $(obj).css("font-weight", "bold");
                }
            });

            $($(instance).find('td[data-x="1"]')).each(function (i, obj) {
                if (i == 0) {
                    $(obj).css("font-weight", "bold");
                }
            });

            //$($(instance).find('.jexcel_filter')).each(function (i, obj) {
            //    $(obj).prepend($("#people-autoadmit-header-checkin-title"));
            //});

            $(".jexcel_search").css({ "border": "1px solid #ccc" });

   



        },
        onchange: function (obj, cel, val) {
            //// Used to avoid onchange event to propagate
            //if (autoAdmitTableOnChangeDisabled) {
            //    return;
            //}

            //var checkinId = 0;
            //var newValue = "";
            //var columnToUpdate = "";



            ////Grid coordinates of data just updated
            //var x = parseInt($(cel).attr("data-x"));
            //var y = parseInt($(cel).attr("data-y"));

            ////We changed something in the first row / check in row

            ////Check if the column we changed belongs to the Receiver data information
            //if (x == 0) {
            //    //Get the ID of Receiver data changed

            //    var receiverLookedUp = null;
            //    //Get the string value of the data we just changed
            //    var dataChangedValue = vendorsAutoAdmitTable.getRowData(y)[0];

            //    //Search through receivers that has a property with that data value
            //    for (var i = 0; i < receiversCache.length; i++) {
            //        if (receiversCache[i]['receiverUnit'] == dataChangedValue) {
            //            receiverLookedUp = receiversCache[i];
            //        }
            //    }

            //    //If we didnt find any receiver with corresponding data, return
            //    if (receiverLookedUp == null) {
            //        return;
            //    }

            //    lastReceiverLookedUpCache = receiverLookedUp;

            //    var columnX = 1;

            //    // Dont propagate onchange events
            //    vendorsAutoAdmitTableOnChangeDisabled = true;

            //    // Fetch data from looked up receiver
            //    var columnValue = receiverLookedUp['receiverName'];

            //    // Set internal value
            //    vendorsAutoAdmitTable.setValueFromCoords(columnX, y, columnValue, true);

            //    $($('#autoadmitgrid').find('td[data-x="1"][data-y="' + y + '"]')).each(function (i, obj) {
            //        //Set visual value, since we are using a custom dropdow. Setting the internal data wont update the visual data for some reason
            //        if (i == y) {
            //            $(obj).html(columnValue);
            //        }
            //    });

            //    autoAdmitTableOnChangeDisabled = false;


            //}



        },
        onselection: function (instance, x1, y1, x2, y2, origin) {

            //Used to jump to next column while marking the columnSeperator
            if (x1 == 1) {
                vendorsAutoAdmitTable.updateSelectionFromCoords(x1 + 1, y1, x2 + 1, y2);
                console.log("selected" + x1 + y1 + x2 + y2);
            }
        },
        onbeforechange: function (instance, cell, x, y, value) {

        },
    });

    return 1;

}

function PopulateVendorAutoAdmitTable(vendorsInDatabase) {

    try {
        var vendorAutoAdmitsStrings = [];
        var vendorAutoAdmits = [];

        vendorsInDatabase.forEach(vendor => vendorAutoAdmitsStrings.push(vendor.vendorReceiverAutoAllowList));

        var vendorCount = vendorsInDatabase.length;

        console.log("PopulateVendorAutoAdmitTable");
        console.log(vendorAutoAdmitsStrings);

        for (var k = 0; k < vendorCount; k++) {
            if (vendorAutoAdmitsStrings[k] != null && vendorAutoAdmitsStrings[k] != "") {
                var vendorAutoAdmitForVendor = JSON.parse(vendorAutoAdmitsStrings[k]);
                for (var kx = 0; kx < vendorAutoAdmitForVendor.length; kx++) {

                    var line = vendorAutoAdmitForVendor[kx];

                    vendorAutoAdmits.push([line.VendorName, '', line.ReceiverUnit, line.VendorAutoAdmitName, line.VendorAutoAdmitReceiverRelation,
                        line.VendorAutoAdmitDue, timestampToJexcelDate(line.VendorAutoAdmitDueFrom), timestampToJexcelDate(line.VendorAutoAdmitDueTo), line.VendorAutoAdmitBanned, line.VendorAutoAdmitComment, '<div class="create-pass-in-grid-btn" onclick="GenerateVendorAutoAdmitPass()" style="background-color:#fff;border-radius:2px;color:#1b6ec2;">Create</div>']);
                }
            }

        }

        if (vendorsAutoAdmitTable != null) {
            vendorsAutoAdmitTable.setData(vendorAutoAdmits, false);
        } else {
        }

    } catch (e) {
        console.log("PopulateAutoAdmitTable Error");
        console.log(e);
    }

    return 1;
}

function ReadVendorAutoAdmitGrid() {
    var resultr = []
    var datar = vendorsAutoAdmitTable.getJson(false);

    var rowCount = 100;
    if (datar != null) {
        rowCount = datar.length;
    }

    for (var i = 0; i < rowCount; i++) {
        var line = datar[i];
        if (line[0] && line[0] != "") {

            var vendorAutoAdmitName = line[3];
            try {
                vendorAutoAdmitName = vendorAutoAdmitName.trim();
            } catch (e) {

            }


            var row = {
                VendorName: line[0],
                ReceiverUnit: line[2],
                VendorAutoAdmitName: vendorAutoAdmitName,
                VendorAutoAdmitReceiverRelation: line[4],
                VendorAutoAdmitDue: line[5],
                VendorAutoAdmitDueFrom: jexcelDateTimeParse(line[6]),
                VendorAutoAdmitDueTo: jexcelDateTimeParse(line[7]),
                VendorAutoAdmitBanned: line[8],
                VendorAutoAdmitComment: line[9],
            };

            resultr.push(row);
        }
    }
    return resultr;
}


function PopulateVendorsTable(vendorsInDatabase) {
    var vendors = [];

    vendorsInDatabase.forEach(vendor => vendors.push([
        vendor.vendorName,
        vendor.vendorType,
        vendor.vendorRepresentative,
        vendor.vendorVehicleRegistrationPlate,
        vendor.vendorInsuranceRequired,
        vendor.vendorInsuranceOnFile,
        timestampToJexcelDate(vendor.vendorInsuranceExpirationDate),
        vendor.vendorComment]))

    try {
        if (vendorsTable != null) {
            vendorsTable.setData(vendors, false);
        } else {
        }
    } catch (e) {
        console.log(e);
    }

    return 1;
}


function SaveVendorsTable(args) {
    try {
        var result = []
        var data = vendorsTable.getJson(false);
        console.log(data);

        var vendorAutoAdmitList = ReadVendorAutoAdmitGrid();

        console.log("vendorAutoAdmitList");
        console.log(vendorAutoAdmitList);

        var vendorAutoAdmitCount = 0;
        if (vendorAutoAdmitList != null) {
            vendorAutoAdmitCount = vendorAutoAdmitList.length;
        }

        var rowCount = 100;
        if (data != null) {
            rowCount = data.length;
        }

        for (var i = 0; i < rowCount; i++) {
            var line = data[i];
            if (line[0] && line[0] != "") {
                var row = {
                    VendorName: line[0],
                    vendorType: line[1],
                    vendorRepresentative: line[2],
                    vendorVehicleRegistrationPlate: line[3],
                    vendorInsuranceRequired: line[4],
                    vendorInsuranceOnFile: line[5],
                    vendorInsuranceExpirationDate: jexcelDateTimeParse(line[6]),
                    vendorComment: line[7]
                };


                console.log("vendorAutoAdmitCount " + vendorAutoAdmitCount);

                if (vendorAutoAdmitCount > 0) {
                    var allowList = [];

                    var rowVendorName = row.VendorName.toLowerCase();

                   
                    console.log(rowVendorName);

                    for (var j = 0; j < vendorAutoAdmitCount; j++) {
                        try {
                            if (rowVendorName.trimEnd() == vendorAutoAdmitList[j].VendorName.toLowerCase().trimEnd()) {
                                allowList.push(vendorAutoAdmitList[j]);
                            }
                        } catch (e) {

                        }
                    }


                    try {
                        row.VendorReceiverAutoAllowList = JSON.stringify(allowList);
                    } catch (e) {

                    }

                }
                else {
                    row.VendorReceiverAutoAllowList = '';
                }

                result.push(row);
            }
        }
    } catch (e) {
        console.log("Error");
        console.log(e);
    }

    //if (result == null || result.length == 0) {
    //    alert("Empty alert");
    //}
    return result;
}



//
//vendor types grid

var defaultVendors = [["Private Landscaper", ""], ["Private Contractor", ""], ["Realtor", ""], ["Food/Water Delivery", ""], ["Transportation", ""], ["\"123\"", ""], ["In-house vendor", ""], ["Dry Cleaners", ""], ["Floral Delivery", ""], ["Dog Groomer", ""], ["Pet Care", ""], ["Pest Control", ""], ["Other", ""] ];

function setDefaultVendors() {

    if (vendorsTypesTable != null) {
        vendorsTypesTable.setData(defaultVendors, false);
    } else {
    }

}


function PopulateVendorsTypesTable(vendorsTypeInDatabase) {
    var vendorsTypes = [];

    try {
        vendorsTypeInDatabase.forEach(vendor => vendorsTypes.push([
            vendor.vendorTypeName,
            vendor.vendorTypeDescription,]))

        if (vendorsTypesTable != null) {
            console.log("vendortypes");
            console.log(vendorsTypes);
            vendorsTypesTable.setData(vendorsTypes, false);
        } else {
        }
    } catch (e) {
        console.log("PopulateVendorsTypesTable Error");
        console.log(e);
    }

    return 1;
}


function SaveVendorsTypesTable(args) {
    try {
        var result = []
        var data = vendorsTypesTable.getJson(false);
      

        var rowCount = 100;
        if (data != null) {
            rowCount = data.length;
        }

        for (var i = 0; i < rowCount; i++) {
            var line = data[i];
            if (line[0] && line[0] != "") {
                var row = {
                    VendorTypeName: line[0],
                    vendorTypeDescription: line[1]
                };

                result.push(row);
            }
        }
    } catch (e) {
        console.log("Error");
        console.log(e);
    }

    //if (result == null || result.length == 0) {
    //    alert("Empty alert");
    //}
    return result;
}



//





function SaveVendorsLogTable(args) {
    try {
        var result = []
        var data = awayLogTable.getJson(false);
        console.log(data);

        for (var i = 0; i < 100; i++) {
            var line = data[i];
            if (line[0] && line[0] != "") {
                //3,4,7,8

                //Datetime columns

                //////////////////////////

                line[3] = jexcelDateTimeParse(line[3]);
                line[4] = jexcelDateTimeParse(line[4]);
                line[7] = jexcelDateTimeParse(line[7]);
                line[8] = jexcelDateTimeParse(line[8]);

                //////////////////////////

                var row = {
                    VendorUnit: line[0],
                    VendorName: line[1],
                    VendorAwayEnabled: line[2],
                    VendorAwayFrom: line[3],
                    VendorAwayTo: line[4],
                    VendorHoldsEnabled: line[5],
                    VendorHoldsWhat: line[6],
                    VendorHoldsFrom: line[7],
                    VendorHoldsTo: line[8],
                    VendorHoldsOther: line[9],
                    VendorHoldsComment: line[10]
                };


                result.push(row);
            }
        }

        console.log("result");
        console.log(result);

    } catch (e) {
        console.log("Error");
        console.log(e);
    }
    return result;
}


function showVendorsNotificationToast(message) {
    var x = document.getElementById("snackbarVendors");
    x.className = "show";
    x.innerHTML = message;
    setTimeout(function () { x.className = x.className.replace("show", ""); x.innerHTML = ""; }, 3000);
}

function GenerateVendorAutoAdmitPass() {
    try {
        var rowNumber = vendorsAutoAdmitTable.getSelectedRows();

        console.log("selected rows:");
        console.log(rowNumber);

        var rowData = "";

        for (var i = 1; i < 10; i++) {
            rowData += rowNumber[0].cells[i].innerHTML + ";";
        }


       // DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnGenerateVendorAutoAdmitPass', rowData);

        vendorsAutoAdmitTable.resetSelection();
    } catch (e) {
        console.log(e);
    }
}